import React from "react";
import { TopicTable } from "./TopicTable";
import { useRecentTopicsRecursive } from "@/hooks/useRecentTopicsRecursive";

interface Props {
  categoryId: string;
  stateName: string;
}

export const StateRecentTopics: React.FC<Props> = ({ categoryId, stateName }) => {
  const { data, isLoading } = useRecentTopicsRecursive(categoryId, 10);

  if (!isLoading && (!data || data.length === 0)) return null;

  const topics =
    data?.map((t) => ({
      ...t,
      username: t.author_username || null,
      avatar_url: t.author_avatar_url || null,
      category_name: t.category_name || "General",
      category_color: t.category_color || "#3b82f6",
      category_slug: t.category_slug || "",
      hot_score: 0,
      last_post_id: null,
    })) || [];

  return (
    <div className="forum-spacing">
      <h2 className="text-lg sm:text-xl font-semibold text-gray-900">
        Recent Topics in {stateName}
      </h2>
      <p className="text-sm text-gray-600">
        The latest discussions from {stateName} and its youth baseball subforums.
      </p>
      <TopicTable topics={topics} loading={isLoading} showCategory={true} />
    </div>
  );
};

export default StateRecentTopics;
